import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "uk-spinner": ""
}
const _hoisted_2 = {
  key: 1,
  class: "uk-container"
}
const _hoisted_3 = { class: "uk-table uk-table-small uk-margin-remove" }
const _hoisted_4 = { class: "uk-padding-remove" }
const _hoisted_5 = { class: "uk-padding-remove" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "uk-padding-remove" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "uk-text-right" }
const _hoisted_11 = { class: "uk-flex uk-flex-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Receivable", -1)),
    (_ctx.$apollo.queries.container.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("th", null, "Rate Name"),
              _createElementVNode("th", null, "Rate Type"),
              _createElementVNode("th", null, "Amount")
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charges, (charge, chargeIdx) => {
                return (_openBlock(), _createElementBlock("tr", { key: chargeIdx }, [
                  _createElementVNode("td", _hoisted_4, _toDisplayString(charge.name), 1),
                  _createElementVNode("td", _hoisted_5, [
                    (charge.type === 'base')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Base"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, "Flat"))
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _cache[0] || (_cache[0] = _createTextVNode(" $", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-width-small uk-form-small",
                      "onUpdate:modelValue": ($event: any) => ((charge.amount) = $event)
                    }, null, 8, _hoisted_9), [
                      [_vModelText, charge.amount]
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", {
                  colspan: "2",
                  class: ""
                }, "Total for Container", -1)),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.container.containerTotal), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              onClick: _ctx.updateLoadCharges,
              class: "uk-flex"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Update Charges", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
  ]))
}